/**
 * Exame toxicológico do motorista profissional (Lei 13.103/2015).
 *
 * O ciclo tem dois momentos: a clínica registra a COLETA e, dias depois, lança
 * o LAUDO que o laboratório devolveu. Por isso quase todo campo é opcional —
 * até o laudo chegar, o registro existe pela metade, e isso é o normal.
 */

export const RESULTADO_TOXICOLOGICO = {
  NEGATIVO: 'NEGATIVO',
  POSITIVO: 'POSITIVO',
  INCONCLUSIVO: 'INCONCLUSIVO',
} as const;

export type ResultadoToxicologico =
  (typeof RESULTADO_TOXICOLOGICO)[keyof typeof RESULTADO_TOXICOLOGICO];

export const RESULTADO_LABELS: Record<string, string> = {
  NEGATIVO: 'Negativo',
  POSITIVO: 'Positivo',
  INCONCLUSIVO: 'Inconclusivo',
};

export interface ToxicologicalExam {
  id: number;
  appointmentId: number;
  collectionDate: string;
  laboratoryCnpj: string | null;
  examSequenceCode: string | null;
  result: string | null;
  resultDate: string | null;
  notes: string | null;
  createdAt: string;
  updatedAt: string;
  /** Calculado pelo servidor: coleta + 30 meses. */
  proximoVencimento: string | null;
  /** O laudo trouxe o que o S-2221 exige? */
  prontoParaEsocial: boolean;
}

export interface DadosDaColeta {
  appointmentId: number;
  collectionDate: string;
  notes?: string | null;
}

export interface DadosDoLaudo {
  laboratoryCnpj?: string | null;
  examSequenceCode?: string | null;
  result?: string | null;
  resultDate?: string | null;
  notes?: string | null;
}

/** O que o servidor diria ao eSocial, e o que ainda falta para poder dizer. */
export interface PreviaEsocial {
  metadata: Record<string, unknown>;
  gaps: string[];
}
